import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=236fb2d6&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=236fb2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fb2d6",
  null
  
)

export default component.exports